<template>
  <a-modal
    v-model="visibleAdd"
    class="modal"
    width="1000px"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel(false)"
  >
  <div slot="title" class="tip-icon"> {{title}} </div>
    <div class="message">

      <a-form-model ref="ruleForm" :model="content" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
    
        <a-row>
          <a-col :span="12">
        <a-form-model-item label="等级名称" prop="gradeName" >
          <a-input placeholder="请输入等级名称" v-model="content.gradeName" />
        </a-form-model-item>
      </a-col>
      <a-col :span="12">
        <a-form-model-item label="等级编号" prop="gradeCode">
          <a-input placeholder="请输入等级编号" v-model="content.gradeCode" />
        </a-form-model-item>
        </a-col>
        </a-row>
        <a-row>
      <a-col :span="12">
          <a-form-model-item label="规则值域开始值" prop="beginVal">
            <a-input-number placeholder="请输入开始值" v-model="content.beginVal" class="input-number-order"/>
          </a-form-model-item>
      </a-col>
      <a-col :span="12">
          <a-form-model-item label="规则值域结束值" prop="endVal">
            <a-input-number placeholder="请输入结束值" v-model="content.endVal" class="input-number-order"/>
          </a-form-model-item>
      </a-col>
      </a-row>
      <a-row>
          <a-col :span="12">
        <a-form-model-item label="消费折扣" prop="useRebate">
          <a-select v-model="content.useRebate" placeholder="请选择消费折扣">
            <a-select-option v-for="item in usrMemList" :key="item.value" :value="item.value">
                {{ item.label }}
             </a-select-option>
          </a-select>
        </a-form-model-item>
        </a-col>
        <a-col :span="12">
        <a-form-model-item label="等级状态"  prop="serStatus">
          <a-select v-model="content.serStatus" placeholder="请选择等级状态">
            <a-select-option v-for="item in usrTpList" :key="item.value" :value="item.value">
                {{ item.label }}
             </a-select-option>
          </a-select>
        </a-form-model-item>
  </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
        <a-form-model-item label="说明" :label-col="{span:3}" :wrapper-col="{span:20}" prop="gradeRemark">
          <a-input v-model="content.gradeRemark" type="textarea" style="height: 80px;"  placeholder="请输入备注"/>
        </a-form-model-item>
        </a-col>
      </a-row>
      </a-form-model>
   
  </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="btaction" @click="handleOk" :loading="disabled"
        >确 定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import
{
  addVipGrade,
  vipGrageById,
  updateVipGrade
}
from '@/api/api.js'
import { DictionaryService } from '@common/services/dictionary.service'
export default {
  name: 'userAddModal',
  props: ['visible', 'userData', 'type', 'title'],
  data() {
    var checkAge = (rule, value, callback) => {
      if (value) {
        if (value < 0) {
          return callback(new Error('请输入大于等于0的数'));
        }
        if (value > 10000000) {
          return callback(new Error('不能超过1000万元'));
        }
        return callback();
      } else {
        return callback();
      }
    };
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      usrTpList: [],
      usrMemList:[],
      content: {
        beginVal: undefined,
        endVal: undefined,
        gradeCode: '',
        gradeName: '',
        gradeRemark: '',
        serStatus: undefined,
        useRebate:undefined,
      },
      disabled: false,
      visibleAdd: this.visible,
      rules: {
        gradeCode: [
          {
            required: true,
            message: '等级编号不能为空！',
            trigger: 'blur',
           
          },
          {
            max: 63,
            message: '等级编号长度不能超过63',
           
          }
        ],
        gradeName: [
          {
            required: true,
            message: '等级名称不能为空！',
            trigger: 'blur',
          },
          {
            max: 180,
            message: '等级名称长度不能超过180',
           
          }
        ],
        useRebate: [
          {
            required: true,
            message: '消费折扣不能为空!',
            trigger: 'blur',
          }
        ],
        beginVal: [
          {
            required: true,
            message: '开始值不能为空!',
            trigger: 'blur',
          },
          {
            validator: checkAge,
            trigger: "change",
          }
        ],
        endVal : [
          {
            required: true,
            message: '结束值不能为空!',
            trigger: 'blur',
          },
          {
            validator: checkAge,
            trigger: "change",
          }
        ],
        serStatus: [
          {
            required: true,
            message: '请选择等级状态',
            trigger: 'change',
          },
        ],
        gradeRemark: [{
            required: true,
            message: '说明不能为空!',
            trigger: 'blur',
        },
        {
            max: 180,
            message: '说明长度不能超过180',
        }]
      },
    }
  },
  created() {
    if (this.type == 'amend') {
      this.content.id = this.userData.id
      vipGrageById({id:this.content.id}).then((res) => {
        this.content.gradeName = res.content.gradeName
        this.content.gradeCode = res.content.gradeCode
        this.content.gradeRemark = res.content.gradeRemark
        this.content.beginVal = res.content.beginVal
        this.content.endVal = res.content.endVal
        this.content.serStatus = res.content.serStatus
        this.content.useRebate = res.content.useRebate
      })
    }
  },
  computed: {},
  mounted() {

    DictionaryService.getAllNeedDic(["VIP_STATUS","MEM_DISCOUNT"]).then((res) => {
      this.usrTpList = DictionaryService.getOptions("VIP_STATUS");
      this.usrMemList = DictionaryService.getOptions("MEM_DISCOUNT");
    })
  },
  methods: {
    handleOk(e) {
      //弹窗确定
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.disabled = true
          if (this.type == 'add') {
            if (Number(this.content.beginVal) <= Number(this.content.endVal)) {
              addVipGrade(this.content).then(
              (res) => {
                if (res.code == '0000') {
                  this.disabled = false
                  this.success('新增成功')
                  this.$emit('close')
                  this.$emit('queryList')
                }
              },
              (err) => {
                this.disabled = false
                this.$message.error('新增失败')
              }
            ) 
            } else {
              this.disabled = false
              this.$message.error('规则值域开始值应小于结束值')
            }
          } else {
            if (Number(this.content.beginVal) <= Number(this.content.endVal)) {
            updateVipGrade(this.content).then(
              (res) => {
                if (res.code == '0000') {
                  this.disabled = false
                  this.success('修改成功')
                  this.$emit('close')
                  this.$emit('queryList')
                }
              },
              (err) => {
                this.$message.error('修改失败')
                this.disabled = false
              }
            )
            } else {
              this.disabled = false
              this.$message.error('规则值域开始值应小于结束值')
            }
          }
        }
      })
    },
    handleCancel(val) {
      //关闭弹窗
      this.$emit('close',val)
      this.$refs['ruleForm'].resetFields()
    },
    success(title) {
      //提示
      this.$message.success(title, 3)
    },
  },
}
</script>

<style lang="less" scoped="scoped">
.message {
  height: 100%;

  /deep/ .ant-form-item {
    display: flex;
    margin-bottom: 20px !important;
  }
}
/deep/ .input-number-order{
    width: 317px;
  }
</style>

